var _path, _rect, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIdz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 68,
    viewBox: "0 0 186 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.528 21.0134H87.2626V31.7276H106.528V37.1016H81.483C80.4916 37.1016 79.6466 36.7523 78.9481 36.0538C78.2721 35.3553 77.9341 34.5216 77.9341 33.5527V19.4587L74.1149 15.6394H106.528V21.0134ZM132.569 15.6394L144.906 37.1016H134.496L132.569 33.4513H120.976L119.05 37.1016H108.64L119.591 18.0729L117.191 15.6394H132.569ZM123.376 28.8547H130.17L127.094 23.0751H126.452L123.376 28.8547ZM178.869 35.3452L174.815 31.2206H175.457C176.426 31.2206 177.26 30.8714 177.958 30.1729C178.657 29.4744 179.006 28.6406 179.006 27.6718V19.1883C179.006 18.2194 178.657 17.3857 177.958 16.6872C177.26 15.9887 176.426 15.6394 175.457 15.6394H143.991L147.81 19.4587V37.1016H157.138V31.2206H164.777L170.556 37.1016H180.595L180.594 37.1015H185.893L178.869 35.3452ZM169.407 21.0134V25.8466H157.138V21.0134H169.407Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.6218,
    y: 31.4685,
    width: 5.63312,
    height: 5.12102,
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5228 0C39.7548 0 36.5735 7.0106 34.1103 14.4463C33.1061 13.4841 31.7672 12.9499 29.8075 12.9442C26.2886 12.9356 23.6709 15.8306 21.9315 19.4062C20.8186 21.1582 20.4324 23.9957 17.5115 28.0079C17.0737 28.6111 16.6103 29.1338 16.1354 29.5962C15.054 30.6588 13.9096 31.4314 12.8311 32.2413C12.7452 32.3016 12.6565 32.3648 12.5764 32.428C14.4532 27.2469 18.6787 19.2023 19.0592 18.2574C19.6056 16.899 18.6158 14.7162 13.8524 14.9776C13.8524 14.9776 11.9299 18.5848 10.1189 22.4649C7.55845 26.9309 3.92513 32.0604 0 33.8008C0 33.8008 1.95684 38.4879 4.58885 35.7911C5.54153 34.8175 6.31969 34.0162 6.98627 33.3097C7.41827 37.3679 10.4222 37.1036 11.5408 36.8566C11.7582 36.8049 11.9041 36.7619 11.947 36.7475C11.947 36.7475 11.9499 36.7494 11.9556 36.7532C13.2058 35.9376 14.2701 35.4809 17.7174 32.293C18.055 31.9857 18.3611 31.6698 18.6386 31.3596C18.8933 31.0753 19.1221 30.7881 19.3367 30.5037C19.4969 34.3896 21.4394 36.1903 23.9484 36.2018C24.8153 36.2018 25.725 35.57 26.6377 34.536C27.8907 33.1086 29.1352 30.9087 30.2395 28.5737C30.4083 28.2262 30.5685 27.8701 30.7259 27.5168C30.58 28.433 30.5285 29.2458 30.5256 29.9236C30.517 33.7893 32.1678 36.018 34.4193 36.2305C36.4877 36.6843 38.9595 35.6963 41.4284 33.9789L40.1782 31.9742C38.3501 33.1 36.7881 33.4648 35.947 32.5084C35.8097 32.3705 35.6866 32.0604 35.6924 31.3768C35.7095 24.55 42.3697 6.64011 46.1117 2.90074C46.3034 2.70831 46.5895 2.80596 46.5895 2.51589C46.5895 2.03052 44.1062 0.00861558 41.52 0.00287154L41.5228 0ZM28.3942 27.5484C26.9409 30.4635 25.6764 32.5917 25.0127 32.5917C24.8439 32.5917 24.7209 32.4768 24.635 32.293C24.4806 31.9598 24.4376 31.3998 24.4434 30.9058C24.452 26.1986 28.9378 15.5405 31.956 15.6439C32.5769 15.6439 33.1004 16.1235 33.2921 16.942C31.7873 20.2678 29.9792 24.3748 28.3971 27.5455L28.3942 27.5484Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7261 1.34695C20.5901 0.48534 25.7569 1.84381 24.5095 3.09026C23.7428 3.85709 20.8047 9.81079 20.5644 10.0003C19.8921 10.5259 16.7823 9.70166 16.9797 7.9727C17.2744 5.61764 19.1025 1.97017 19.7261 1.34695Z",
    fill: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M19.2882 29.0476L18.6359 31.3538C18.3584 31.664 18.0523 31.9799 17.7147 32.2872C14.2674 35.478 13.2031 35.9347 11.9529 36.7474C11.9529 36.7474 11.9501 36.7455 11.9443 36.7417C11.9043 36.7561 11.7584 36.802 11.5381 36.8508C11.5753 35.5929 11.9701 33.8984 12.5737 32.425C13.6551 31.6151 15.0541 30.653 16.1327 29.5932L19.2882 29.0447V29.0476Z",
    fill: "url(#paint0_linear_54_519)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.2371 28.5679C29.1328 30.9029 27.8883 33.1028 26.6353 34.5302C25.0217 33.8582 24.6984 32.6462 24.6355 32.2929C24.7213 32.4767 24.8443 32.5916 25.0131 32.5916C25.6797 32.5916 26.9414 30.4634 28.3947 27.5483L30.2371 28.5679Z",
    fill: "url(#paint1_linear_54_519)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7742 20.4316C69.1677 20.0209 67.6 20.5609 65.543 21.6752C65.3685 21.7585 65.1968 21.8504 65.0223 21.9366L65.0137 21.9452C63.2171 22.87 61.4262 24.0044 59.7955 25.0671C57.8758 26.3164 51.9567 29.7111 45.6885 34.2834L45.6484 34.315C45.6112 34.3437 45.5712 34.3695 45.534 34.3983C44.9332 34.1972 45.1878 33.4706 45.7857 32.5918C46.8386 31.0351 48.967 29.0046 49.379 28.5594C54.7432 23.5995 60.9055 17.6975 61.1945 15.7502C61.4004 14.5641 58.8228 12.5709 58.0132 12.5422C57.8272 12.5336 55.5528 12.8581 52.5203 12.8581C49.2245 12.7346 45.4053 11.9161 44.7301 11.4623C44.5785 11.3618 44.6471 11.2153 44.4297 11.2613C43.9863 11.3474 43.2911 12.8035 43.6286 14.5095C43.869 15.7416 48.0916 16.675 53.6074 16.3849C48.0087 21.3679 39.0398 30.3832 38.5391 33.8554C38.4018 34.7831 38.7938 35.6907 39.3287 36.4029C39.8837 37.1439 40.5818 37.6752 40.9938 37.7987C41.0167 37.8045 41.0624 37.8045 41.1254 37.8045C40.6734 38.1692 40.2328 38.5426 39.7893 38.9159C39.7893 38.9159 39.7865 38.9179 39.7808 38.9217V38.9274C38.5363 39.9843 37.329 41.0786 36.1846 42.2044C32.434 45.8777 29.3643 49.8497 28.0626 53.8332C27.416 55.8063 27.2015 57.7822 27.5534 59.7266C29.1955 68.8366 40.5475 69.0607 46.6841 65.6114C54.1224 61.424 58.6998 54.9389 59.9357 49.4361C60.3104 47.7704 60.3791 46.1908 60.1216 44.795C58.8314 37.7154 54.254 35.8027 52.8779 35.3776C52.895 35.369 52.9151 35.3546 52.9322 35.346C54.4857 34.3667 56.1593 33.35 57.996 32.2615C59.0803 31.6526 60.2618 30.9892 61.4777 30.2941C61.4834 30.2941 61.4863 30.2941 61.4863 30.2884C63.2285 29.2947 65.028 28.2435 66.7245 27.2125C66.7474 27.1981 66.7646 27.1895 66.7875 27.1751C66.9792 27.0574 67.1708 26.9425 67.3568 26.8276C69.162 25.8109 70.5553 25.1446 71.7511 24.9148C71.9886 24.8689 72.1516 25.09 72.2975 24.8746C72.5436 24.5128 71.7053 21.7441 69.7828 20.4316H69.7742ZM55.0693 46.656C55.0693 47.4028 54.9863 48.1897 54.7947 49.014C54.2482 51.3891 52.8207 54.0888 49.9998 57.0815C45.883 61.4556 42.0094 63.3138 38.9883 63.4889C38.9254 63.4947 38.8596 63.5033 38.7966 63.5033C34.2478 63.667 31.6759 59.9851 33.1521 55.3755C34.574 50.9468 38.2988 46.6503 42.1238 43.2412C43.437 42.0694 44.7673 41.0039 46.0175 40.0705C46.0318 40.0619 46.0461 40.0533 46.0575 40.0389C46.2034 39.9298 46.3436 39.8292 46.4867 39.723C46.6926 39.5708 46.8729 39.43 47.0388 39.2979C47.0474 39.2893 47.0617 39.2836 47.0703 39.2692C47.1103 39.2376 47.1532 39.2003 47.1933 39.1687C47.4107 39.0136 47.631 38.8585 47.8542 38.7005C47.9486 38.6316 48.0516 38.5627 48.1517 38.4909C48.3748 38.3387 48.6037 38.1807 48.8297 38.0227C50.3031 38.376 51.6734 39.0021 52.6118 40.0734C53.8506 41.6099 55.0693 43.8357 55.0693 46.6589V46.656Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.1551 55.3725C31.6789 59.9792 34.248 63.664 38.7996 63.5003C30.3772 64.2155 28.4747 56.7367 28.057 53.8302C29.3616 49.8496 32.4284 45.8776 36.179 42.2014L42.1268 43.2353C38.3018 46.6444 34.5798 50.941 33.1551 55.3696V55.3725Z",
    fill: "url(#paint2_linear_54_519)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M46.0575 40.036C46.3264 39.8292 46.6497 39.5794 47.0388 39.295C46.8757 39.4272 46.6926 39.5708 46.4866 39.7201C46.3464 39.8264 46.2034 39.9269 46.0575 40.036Z",
    fill: "url(#paint3_linear_54_519)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M59.9242 49.4333L54.7975 49.0111C54.9892 48.1868 55.0722 47.3999 55.0722 46.6532C55.0722 43.83 53.8563 41.607 52.6147 40.0676C51.6763 38.9964 50.3031 38.3703 48.8326 38.017C48.6037 38.1721 48.3777 38.3329 48.1545 38.4852C49.3533 37.6379 50.9182 36.581 52.8721 35.3748C54.2482 35.7998 58.8256 37.7126 60.1159 44.7921C60.3705 46.1879 60.3018 47.7675 59.9299 49.4333H59.9242Z",
    fill: "url(#paint4_linear_54_519)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1983 32.8674C40.1983 32.8674 40.1857 32.8751 40.1781 32.8801L40.1983 32.8674Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7855 32.5888C45.1876 33.4676 44.9329 34.1942 45.5337 34.3953C45.5709 34.3665 45.611 34.3407 45.6482 34.312L41.1165 37.8044C41.0536 37.8044 41.0078 37.8044 40.9849 37.7986C40.5758 37.6751 39.8778 37.1438 39.3199 36.4028L38.7391 35.4608L45.8484 31.4285L45.7855 32.5859V32.5888Z",
    fill: "url(#paint5_linear_54_519)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_519",
    x1: 10.0705,
    y1: 36.0467,
    x2: 17.5394,
    y2: 30.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_519",
    x1: 22.8103,
    y1: 35.2166,
    x2: 28.6951,
    y2: 30.0324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54_519",
    x1: 32.1595,
    y1: 63.552,
    x2: 35.4015,
    y2: 51.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_54_519",
    x1: 46.5295,
    y1: 39.6368,
    x2: 46.5439,
    y2: 39.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_54_519",
    x1: 49.1415,
    y1: 33.6889,
    x2: 54.485,
    y2: 41.3578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_54_519",
    x1: 44.6926,
    y1: 38.666,
    x2: 42.3345,
    y2: 33.5751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#AEAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFCFCF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E3E3E3",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F2F2F2",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBFBFB",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdz);
export default __webpack_public_path__ + "static/media/logo-idz.bf5837eda1e7bbabf049f51b5b5d4fb6.svg";
export { ForwardRef as ReactComponent };